export const DISPLAY_GROUP_BOARD_ITEM_TYPE = "DISPLAY_GROUP_BOARD_ITEM";
export const DISPLAY_GROUP_POOL_PARAMETER_TYPE = "DISPLAY_GROUP_POOL_PARAMETER";

export type DisplayGroupBoardDragItem = {
  index: number;
};

export type DisplayGroupPoolDragItem = {
  parameterId: string;
};

export function isPoolDragItem(
  item: DisplayGroupBoardDragItem | DisplayGroupPoolDragItem,
): item is DisplayGroupPoolDragItem {
  return "parameterId" in item;
}
